import React from 'react';

import { Typography, Button } from '@mui/material';

const StepTwoStatus = (props) => {
  return (
    <React.Fragment>
      <Typography variant='h5' sx={{ mt: '3rem', fontWeight: 'bold' }}>
        Outcome Status
      </Typography>
      <Button variant='outlined' sx={{ mt: '1rem' }}>
        {props.activeStep === 2 ? 'YOU ARE A MEMBER' : 'IN PROGRESS'}
      </Button>
    </React.Fragment>
  );
};

export default StepTwoStatus;
